import type { ComponentProps } from 'react';
import { InputErrorMessage } from '@savvy-kit/components/input-error-message';
import { cn } from '@savvy-kit/lib/utils';

type TextareaProps = ComponentProps<'textarea'> & {
  error?: boolean;
  errorMessage?: string;
  size?: 'default' | 'lg';
};

function Textarea({ className, error, errorMessage, size = 'default', ...props }: TextareaProps) {
  const showErrorMessage = error && errorMessage;

  return (
    <div className="w-full">
      <textarea
        data-slot="textarea"
        className={cn(
          'text-sm placeholder:text-secondary selection:bg-info-foreground-light selection:text-dark w-full min-w-0 rounded-md border border-light bg-card px-3 py-1 text-dark shadow-xs transition-[color,box-shadow] outline-none min-h-24',
          // Disabled state
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          // Focus state
          'focus-visible:border-primary focus-visible:ring-border-light focus-visible:ring-2',
          // Invalid state
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          'file:text-dark file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:pr-1',
          size === 'lg' && 'text-base',
          className,
        )}
        aria-invalid={error}
        {...props}
      />

      <div className={cn('text-xs pt-1', !showErrorMessage && 'hidden')}>
        {showErrorMessage && <InputErrorMessage message={errorMessage} />}
      </div>
    </div>
  );
}

export { Textarea };
